export default "__VITE_ASSET__17b3a92e__"